import type { AbortControllerService } from '@app/services/AbortControllerService'

import { createThunk } from '@app/store/thunk'

export function getAbortControllerService() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<AbortControllerService>(AbortControllerServiceSymbol))
}
export function setAbortControllerService(value: AbortControllerService) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(AbortControllerServiceSymbol, value))
}

const AbortControllerServiceSymbol = Symbol('AbortControllerService')
